module.exports = __webpack_public_path__ + "img/9.fa2cdb5d.png";